// Deterministic little avatar (initial + stable gradient from an id/name). Used
// for message authors, members, and agents in the workspace layout. The
// gradient (rather than a flat fill) gives each identity a bit more presence.

const HUES = [210, 265, 330, 12, 32, 152, 190, 288];

function hashOf(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return h;
}

function gradientFor(seed: string): string {
  const h = hashOf(seed);
  const hue = HUES[h % HUES.length];
  const hue2 = (hue + 28) % 360;
  return `linear-gradient(135deg, hsl(${hue} 62% 58%), hsl(${hue2} 64% 46%))`;
}

function initialOf(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";
  return [...trimmed][0].toUpperCase();
}

export function Avatar({ name, id, size = 36 }: { name: string; id?: string; size?: number }) {
  const seed = id || name;
  return (
    <span
      className="ws-avatar"
      style={{ width: size, height: size, backgroundImage: gradientFor(seed), fontSize: Math.round(size * 0.42) }}
      aria-hidden
    >
      {initialOf(name)}
    </span>
  );
}
